"use strict";

exports.__esModule = true;
exports.vehicleKeyMap = exports.tradeInKeys = exports.tabIndexMap = exports.rebatesAndTaxesKeys = exports.rebateCodes = exports.downPaymentKeys = exports.DEFAULT_LEASE_TERM = exports.DEFAULT_FINANCE_TERM = exports.DEFAULT_DISPLAY_VALUE = void 0;
var DEFAULT_FINANCE_TERM = exports.DEFAULT_FINANCE_TERM = 72;
var DEFAULT_LEASE_TERM = exports.DEFAULT_LEASE_TERM = 39;
var DEFAULT_DISPLAY_VALUE = exports.DEFAULT_DISPLAY_VALUE = '-';
var vehicleKeyMap = exports.vehicleKeyMap = {
  SELECTED_MODEL_INDEX: 'selectedModelIndex',
  SELECTED_TAB_INDEX: 'selectedTabIndex',
  PAYMENT_MODEL: 'paymentModel',
  DOWN_PAYMENT: 'downPaymentAmount',
  FINANCE_DOWN_PAYMENT: 'financeDownPayment',
  LEASE_DOWN_PAYMENT: 'leaseDownPayment',
  TRADE_IN_VALUE: 'tradeInValue',
  FINANCE_TRADE_IN_VALUE: 'financeTradeInValue',
  LEASE_TRADE_IN_VALUE: 'leaseTradeInValue',
  CASH_TRADE_IN_VALUE: 'cashTradeInValue',
  RATE: 'rate',
  FINANCE_TERM: 'financeTerm',
  LEASE_TERM: 'leaseTerm',
  ANNUAL_MILEAGE: 'annualMileage',
  INCLUDE_TAX: 'includeTax',
  INCLUDE_FEE: 'includeFee',
  REBATES: 'rebates'
};
var tradeInKeys = exports.tradeInKeys = [vehicleKeyMap.TRADE_IN_VALUE, vehicleKeyMap.FINANCE_TRADE_IN_VALUE, vehicleKeyMap.LEASE_TRADE_IN_VALUE, vehicleKeyMap.CASH_TRADE_IN_VALUE];
var downPaymentKeys = exports.downPaymentKeys = [vehicleKeyMap.DOWN_PAYMENT, vehicleKeyMap.LEASE_DOWN_PAYMENT, vehicleKeyMap.FINANCE_DOWN_PAYMENT];
var rebatesAndTaxesKeys = exports.rebatesAndTaxesKeys = [vehicleKeyMap.INCLUDE_TAX, vehicleKeyMap.INCLUDE_FEE, vehicleKeyMap.REBATES];
var tabIndexMap = exports.tabIndexMap = {
  LEASE: 0,
  FINANCE: 1,
  CASH: 2
};
var rebateCodes = exports.rebateCodes = {
  PROVINCIAL_EV_REBATE: "provincial_govt_ev",
  FEDERAL_EV_REBATE: "federal_govt_ev"
};